import { render, staticRenderFns } from "./UserBuildingPermissionSelectList.vue?vue&type=template&id=1f8617e0&scoped=true"
import script from "./UserBuildingPermissionSelectList.vue?vue&type=script&lang=js"
export * from "./UserBuildingPermissionSelectList.vue?vue&type=script&lang=js"
import style0 from "./UserBuildingPermissionSelectList.vue?vue&type=style&index=0&id=1f8617e0&prod&scoped=true&lang=css"
import style1 from "./UserBuildingPermissionSelectList.vue?vue&type=style&index=1&id=1f8617e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8617e0",
  null
  
)

export default component.exports